import { ITreeControl } from '@infotech-soe/metaschema';

import {
  FormControlViewModelType,
  TreeFormControlViewModel,
} from '../../view-model/FormControlViewModel';
import { FormSourceType } from '../../view-model/FormSource';
import { FormViewModel } from '../../view-model/FormViewModel';

const buildTreeControl = async (
  item: ITreeControl,
  viewModel: FormViewModel,
  label: string
): Promise<TreeFormControlViewModel> => ({
  columns: item.columns,
  type: FormControlViewModelType.TREE,
  name: item.name,
  noLabel: item.noLabel,
  labelWidth: item.labelWidth,
  hasValue: true,
  hasHistory: false,
  label,
  value: '',
  required: item.required,
  storeValue: item.storeValue,
  disabled: item.disabled,
  visible: item.visible,
  readonly: item.readonly || viewModel.source.type === FormSourceType.REVIEW,
  trim: item.trim,
});

export default buildTreeControl;
